export const CONTACT = {
  landline: "0161 915 4845",
  mobile: "07778 697063",
  phone: "07778 697063",
  email: "hello@risiwellness.co.uk",
  whatsapp: "447778697063", // international format, digits only
  address: "Bartle House, 9 Oxford Court, Manchester, England, M2 3WQ",
  hours: [
    { day: "Monday – Friday", time: "8:00am – 8:00pm" },
    { day: "Saturday", time: "9:00am – 6:00pm" },
    { day: "Sunday", time: "10:00am – 4:00pm" },
  ],
  area: "Manchester & surrounding areas (10-mile radius)",
  socials: {
    facebook: null,
    instagram: "https://www.instagram.com/risiwellnessuk/",
    tiktok: "https://www.tiktok.com/@risiwellnesshub",
    linkedin: null,
  },
  googleBusinessProfile: "https://share.google/q4UHXlOk0dqEDo9r",
};

export const IMAGES = {
  heroBg: "https://images.pexels.com/photos/7031704/pexels-photo-7031704.jpeg",
  massage: "https://images.unsplash.com/photo-1745327883508-b6cd32e5dde5",
  hotStones: "https://images.unsplash.com/photo-1696841212541-449ca29397cc",
  aromatherapy: "https://images.pexels.com/photos/19572633/pexels-photo-19572633.jpeg",
  manifesto: "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2",
  footMassage: "https://images.pexels.com/photos/9146381/pexels-photo-9146381.jpeg",
  twoMassage: "https://images.pexels.com/photos/18120174/pexels-photo-18120174.jpeg",
  meditation: "https://images.pexels.com/photos/7878206/pexels-photo-7878206.jpeg",
  lakeside: "https://images.pexels.com/photos/33788302/pexels-photo-33788302.jpeg",
  garden: "https://images.unsplash.com/photo-1769238507012-0c98e68582a9",
  sunTree: "https://images.unsplash.com/photo-1635725277998-6c8ffdfb6b1b",
  products: "https://images.pexels.com/photos/16678264/pexels-photo-16678264.jpeg",
  dropper: "https://images.pexels.com/photos/7795756/pexels-photo-7795756.jpeg",
};

export const SERVICES = [
  {
    slug: "classic-swedish",
    name: "The Classic Swedish",
    group: "Signature Collection",
    tagline: "The foundation of relaxation.",
    image: IMAGES.massage,
    description:
      "Long, rhythmic strokes across the body. This treatment is part of the Signature Collection and is available in 60- and 90-minute appointments.",
    benefits: ["Long rhythmic strokes", "Full-body format", "60- or 90-minute options", "Signature Collection"],
    durations: ["60 Minutes", "90 Minutes"],
    idealFor: "Anyone new to massage, or seeking pure relaxation and stress relief.",
  },
  {
    slug: "lomi-lomi-flow",
    name: "The Lomi Lomi Flow",
    group: "Signature Collection",
    tagline: "A seamless wave of relaxation.",
    image: IMAGES.twoMassage,
    description:
      "A rhythmic, continuous treatment inspired by Hawaiian flow techniques, using long forearm glides across the back and limbs.",
    benefits: ["Continuous flowing movements", "Forearm glides", "Back and limb focus", "Signature Collection"],
    durations: ["60 Minutes", "90 Minutes"],
    idealFor: "Those who love flowing, uninterrupted, meditative bodywork.",
  },
  {
    slug: "risi-rhythmic",
    name: "The Risi Rhythmic",
    group: "Signature Collection",
    tagline: "African Fusion — bespoke & grounding.",
    image: IMAGES.footMassage,
    description:
      "A bespoke treatment using rhythmic patterns and body-weight techniques. This is Risi Wellness' signature house method.",
    benefits: ["Bespoke treatment", "Rhythmic patterns", "Body-weight techniques", "Signature house method"],
    durations: ["60 Minutes"],
    idealFor: "Clients seeking a unique, deeply restorative signature experience.",
  },
  {
    slug: "aromatherapy",
    name: "Aromatherapy Massage",
    group: "Specialist Therapies",
    tagline: "Relaxation elevated by essential oils.",
    image: IMAGES.aromatherapy,
    description:
      "A massage incorporating professional-grade essential oils selected for the appointment.",
    benefits: ["Essential-oil massage", "Professional-grade oils", "Sensory treatment format", "Specialist Therapy"],
    durations: ["60 Minutes"],
    idealFor: "Those seeking sensory relaxation and emotional balance.",
  },
  {
    slug: "deep-tissue",
    name: "Deep Tissue Release",
    group: "Specialist Therapies",
    tagline: "Focused pressure for stubborn tension.",
    image: IMAGES.hotStones,
    description:
      "A slower, focused massage using controlled pressure and techniques for selected areas of muscle tension.",
    benefits: ["Slower focused massage", "Controlled pressure", "Areas of muscle focus", "60- or 90-minute options"],
    durations: ["60 Minutes", "90 Minutes"],
    idealFor: "Athletes, active individuals, and those with chronic tension.",
  },
  {
    slug: "thermotherapy",
    name: "Thermotherapy",
    group: "Specialist Therapies",
    tagline: "Hot & Cold Stone therapy.",
    image: IMAGES.products,
    description:
      "A temperature-based treatment using heated and cooled stones.",
    benefits: ["Heated and cooled stones", "Temperature-based treatment", "75-minute appointment", "Specialist Therapy"],
    durations: ["75 Minutes"],
    idealFor: "Those who love warmth and a deeply indulgent experience.",
  },
  {
    slug: "focus-session",
    name: "Focus Session",
    group: "Express & Add-Ons",
    tagline: "Neck, Shoulders & Back.",
    image: IMAGES.dropper,
    description:
      "A targeted express treatment concentrating on the neck, shoulders and back.",
    benefits: ["Targeted express treatment", "Neck, shoulders and back", "30-minute appointment"],
    durations: ["30 Minutes"],
    idealFor: "Busy professionals and anyone short on time.",
  },
  {
    slug: "leg-foot-treatment",
    name: "Revitalising Leg & Foot Treatment",
    group: "Express & Add-Ons",
    tagline: "Refresh tired legs & feet.",
    image: IMAGES.meditation,
    description:
      "An express treatment for the legs and feet.",
    benefits: ["Targeted express treatment", "Leg and foot focus", "30-minute appointment"],
    durations: ["30 Minutes"],
    idealFor: "Runners, retail & hospitality workers, frequent travellers.",
  },
  {
    slug: "corporate-wellness",
    name: "Corporate Wellness Sessions",
    group: "Workplace",
    tagline: "Wellbeing for your team.",
    image: IMAGES.garden,
    description:
      "On-site chair and table massage sessions delivered in the workplace for organisations and teams.",
    benefits: ["On-site chair and table massage", "Workplace delivery", "Bespoke packages", "For organisations and teams"],
    durations: ["Bespoke packages — Enquire"],
    idealFor: "Corporate organisations and teams investing in wellbeing.",
  },
];

export const BENEFITS = [
  { icon: "Home", title: "Mobile appointments", text: "Appointments are delivered in a home, hotel or workplace setting." },
  { icon: "Clock", title: "Choice of durations", text: "Treatment pages list the available appointment durations for each service." },
  { icon: "Sparkles", title: "Treatment options", text: "Choose from signature, specialist, express and workplace services." },
  { icon: "CalendarClock", title: "Online booking", text: "Use the booking page to view the current appointment availability." },
  { icon: "MapPin", title: "Manchester service", text: "Risi Wellness serves Manchester and surrounding areas." },
  { icon: "BriefcaseBusiness", title: "Workplace sessions", text: "Corporate Wellness Sessions are available for organisations and teams." },
  { icon: "MessageCircle", title: "Questions welcome", text: "Contact Risi Wellness directly about a treatment or appointment." },
  { icon: "Leaf", title: "Wellness focus", text: "The service menu is focused on massage and holistic wellness treatments." },
];

export const WHY_CHOOSE = [
  { icon: "BadgeCheck", title: "Professional service", text: "Risi Wellness provides mobile massage and holistic wellness appointments." },
  { icon: "Home", title: "Convenient & Mobile", text: "We come to your home, hotel or workplace — no travel required." },
  { icon: "CalendarClock", title: "Online scheduling", text: "Current appointment availability is provided through the booking page." },
  { icon: "Heart", title: "Treatment choice", text: "The menu includes signature, specialist, express and workplace sessions." },
  { icon: "UserCog", title: "Clear service details", text: "Each service page explains its format, duration and intended audience." },
  { icon: "Sparkles", title: "Mobile set-up", text: "The service information describes the equipment and space needed for an appointment." },
  { icon: "Clock", title: "Direct contact", text: "Use the contact page for questions about appointments and service areas." },
  { icon: "Award", title: "Wellness-led", text: "Risi Wellness focuses on massage and holistic wellness treatments." },
];

export const VALUES = ["Professionalism", "Integrity", "Compassion", "Customer Care", "Wellbeing", "Excellence", "Convenience"];

export const TESTIMONIALS = [
  { name: "Seun", role: "Stockport", quote: "Excellent home massage; my stiff shoulder feels so much better, would happily book again." },
  { name: "Catia", role: "Blackburn", quote: "A calming, well-prepared holistic massage right in my own home — I felt wonderfully relaxed." },
  { name: "King", role: "Moston", quote: "Great tension-relief massage that helped my sore back after many long work days." },
  { name: "Sunny", role: "Manchester", quote: "Professional, thoughtful treatment with lovely oils; such a convenient way to unwind." },
  { name: "Kemi", role: "Moston", quote: "Therapist listened well; I left my session feeling calm and much more comfortable." },
];

export const FAQS = [
  { q: "What areas do you cover?", a: "We primarily serve Manchester and surrounding areas within a 10-mile radius of Central Manchester, with travel included. A small surcharge may apply beyond this area." },
  { q: "Do you travel to homes?", a: "Yes — our core service is mobile. We bring a professional couch, fresh linens and oils directly to your home." },
  { q: "Do you visit hotels?", a: "Absolutely. We regularly visit hotels and can also arrange workplace and corporate sessions." },
  { q: "What should I prepare before my appointment?", a: "Simply a quiet, clear space for us to set up. We provide everything else — couch, linens and oils." },
  { q: "How do I pay?", a: "Payment details are confirmed when we contact you to finalise your booking. Online payments are coming soon." },
  { q: "How long are treatments?", a: "Treatments range from 30-minute express sessions to 90-minute signature experiences. Full details are on each service." },
  { q: "Can I cancel or reschedule?", a: "Yes. Please give us as much notice as possible and we'll happily rearrange your appointment." },
  { q: "Are treatments personalised?", a: "Every treatment is tailored to your body, goals and preferences, guided by your health consultation." },
  { q: "What happens during my first session?", a: "Your first session includes a full health consultation so we can tailor your treatment safely and effectively." },
];

// Articles are intentionally omitted until they have approved, original copy and factual dates.
export const BLOG = [];

export const GALLERY = [
  { src: IMAGES.massage, label: "Treatment in progress" },
  { src: IMAGES.products, label: "Hot & cold stones" },
  { src: IMAGES.dropper, label: "Professional-grade oils" },
  { src: IMAGES.twoMassage, label: "Relaxing environment" },
  { src: IMAGES.aromatherapy, label: "Aromatherapy set-up" },
  { src: IMAGES.footMassage, label: "Focused bodywork" },
  { src: IMAGES.meditation, label: "Wellness lifestyle" },
  { src: IMAGES.lakeside, label: "Calm & nature" },
  { src: IMAGES.garden, label: "Balance & wellbeing" },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Benefits", to: "/benefits" },
  { label: "Gallery", to: "/gallery" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];
